import React, { useState } from 'react';
import Chat from "./Chat"
import HealthcareSection from './HealthcareSection';
import Specialists from "./Specialists";
import Footer from './Footer';

const App = () => {
    const [specialists, setSpecialists] = useState([]);
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }} className='container'>
      <header className="container" style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 50, padding: '16px 24px', transition: 'all 0.3s', backgroundColor: '#F7F7F7', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '229px' }}>
          <div style={{ height: '40px', width: '40px', borderRadius: '8px', backgroundColor: '#0055A5', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <span style={{ color: 'white', fontWeight: 'bold', fontSize: '20px' }}>F</span>
          </div>
          <span style={{ fontSize: '20px', fontWeight: '500' }}>Fakeeh Care</span>
        </div>
        <nav style={{ display: 'flex', gap: '16px' }}>
          <a href="#" style={{ color: 'rgba(0,0,0,0.8)', fontWeight: '500', textDecoration: 'none' }}>Home</a>
          <a href="#" style={{ color: 'rgba(0,0,0,0.8)', fontWeight: '500', textDecoration: 'none' }}>Services</a>
          <a href="#" style={{ color: 'rgba(0,0,0,0.8)', fontWeight: '500', textDecoration: 'none' }}>Doctors</a>
          <a href="#" style={{ color: 'rgba(0,0,0,0.8)', fontWeight: '500', textDecoration: 'none' }}>About</a>
        </nav>
        <div style={{ display: 'flex', gap: '16px' }}>
          <button style={{ height: '40px', padding: '8px 16px', borderRadius: '8px', fontWeight: '500', cursor: 'pointer', border: 'none', transition: 'background 0.3s', backgroundColor: 'transparent', color: 'rgba(0,0,0,0.8)' }}>Sign In</button>
          <button style={{ height: '40px', padding: '8px 16px', borderRadius: '8px', fontWeight: '500', cursor: 'pointer', border: 'none', transition: 'background 0.3s', backgroundColor: '#0055A5', color: 'white' }}>Book Appointment</button>
        </div>
      </header>
        <HealthcareSection/>
        <Chat setSpecialists={setSpecialists}/>
        {!!specialists.length && <Specialists />}
        <Footer/>
    </div>
  );
};

export default App;